import store from '../../store/'

export default (to, _, next) => {
  if (
    to.meta.auth !== false &&
    !store.getters['auth/isAuthenticated']
  ) {
    next({ name: 'login' })
  } else {
    next()
  }
}
